// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cardVerificationDetails .el-dialog__title {\n  font-weight: 500;\n  font-family: 'Inter-Medium';\n  font-size: 16px;\n  color: #000000;\n}\n.cardVerificationDetails .header-line {\n  margin: -26px 0 0;\n  border-bottom: 1px solid #D3D7DF;\n}\n", ""]);
// Exports
module.exports = exports;
